import { getApiClient } from "../http/client";
import type { DataResponse } from "../http/types";
import type { ChangePasswordRequest, LoginCredentials, User } from "./types";

export const login = async (credentials: LoginCredentials): Promise<void> => {
  await getApiClient().post<void>("/auth/sign-in", credentials);
};

export const logout = async (): Promise<void> => {
  await getApiClient().post<void>("/auth/sign-out");
};

export const refresh = async (): Promise<void> => {
  await getApiClient().post<void>("/auth/refresh-token");
};

/** 마지막으로 `/users/me` 가 성공한 시각. 세션이 방금 확인됐는지 묻는 데 쓴다. */
let confirmedAt = 0;
let pendingMe: Promise<User> | null = null;

/**
 * 진행 중인 조회가 있으면 그 결과를 같이 쓴다 — 앱이 뜰 때 인증 공급자와 실시간 연결
 * (접속 전 세션 확인)이 거의 동시에 불러 같은 요청이 두 번 나갔다.
 */
export const getMe = (): Promise<User> => {
  pendingMe ??= getApiClient()
    .get<DataResponse<User>>("/users/me")
    .then((response) => {
      confirmedAt = Date.now();
      return response.data;
    })
    .finally(() => {
      pendingMe = null;
    });
  return pendingMe;
};

/**
 * 세션이 `ms` 안에 확인됐는가.
 *
 * 실시간 연결은 접속 전에 `getMe` 로 세션을 깨우는데(만료 쿠키 갱신), 앱이 막 떠서
 * 인증 공급자가 확인한 직후라면 같은 요청을 한 번 더 보낼 이유가 없다.
 */
export const sessionConfirmedWithin = (ms: number): boolean => Date.now() - confirmedAt < ms;

export const changeMyPassword = async (body: ChangePasswordRequest): Promise<void> => {
  await getApiClient().patch<void>("/users/me/password", body);
};
